// pages/AdminDashboard/styles.js

import styled from "styled-components";

export const DashboardWrapper = styled.div`
    min-height: calc(100vh - 64px);
    background: ${props => props.theme.colors.background.alt};
    padding-bottom: ${props => props.theme.spacing.xl};
    overflow-x: hidden; // Prevent horizontal scroll
`;

export const DashboardHeader = styled.div`
    background: white;
    padding: ${props => props.theme.spacing.xl};
    margin-bottom: ${props => props.theme.spacing.xxl};

    h1 {
        font-size: ${props => props.theme.typography.sizes["2xl"]};
        margin-bottom: ${props => props.theme.spacing.sm};
        margin-top: ${props => props.theme.spacing.xxl};
        
        @media (max-width: ${props => props.theme.breakpoints.md}) {
            font-size: ${props => props.theme.typography.sizes.xl};
        }
    }

    p {
        color: ${props => props.theme.colors.text.secondary};
    }
`;

export const TabsContainer = styled.div`
    margin-bottom: ${props => props.theme.spacing.xl};
    width: 100%;
    overflow-x: hidden;
`;

export const TabList = styled.div`
    display: flex;
    gap: ${props => props.theme.spacing.md};
    border-bottom: 1px solid ${props => props.theme.colors.border};
    margin-bottom: ${props => props.theme.spacing.xl};
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    margin: 0 -${props => props.theme.spacing.md}; // Negative margin to allow full scroll
    padding: 0 ${props => props.theme.spacing.md};

    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        gap: ${props => props.theme.spacing.sm};
    }
`;

export const Tab = styled.button`
    padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.lg};
    color: ${props => props.isActive ? props.theme.colors.primary.main : props.theme.colors.text.secondary};
    border-bottom: 2px solid ${props => props.isActive ? props.theme.colors.primary.main : 'transparent'};
    font-weight: ${props => props.isActive ? props.theme.typography.weights.semibold : props.theme.typography.weights.regular};
    transition: all ${props => props.theme.transitions.fast};
    white-space: nowrap; // Prevent text wrapping
    font-size: ${props => props.theme.typography.sizes.md};

    @media (max-width: ${props => props.theme.breakpoints.md}) {
        padding: ${props => props.theme.spacing.sm} ${props => props.theme.spacing.md};
        font-size: ${props => props.theme.typography.sizes.sm};
    }

    &:hover {
        color: ${props => props.theme.colors.primary.main};
    }
`;